import { SubClauseWithCompoundExpression } from "../ars_ldm";
import { isLevelOrder } from "./isLevelOrder";
import { isWhereClauseCompoundExpression } from "./isWhereClauseCompoundExpression";

/**
 * Type guard to check if a value is a SubClauseWithCompoundExpression.
 *
 * @param obj - The value to check
 * @returns True if the value is a SubClauseWithCompoundExpression
 */
export const isSubClauseWithCompoundExpression = (
  obj: unknown,
): obj is SubClauseWithCompoundExpression => {
  // Check basic structure
  if (!isLevelOrder(obj)) return false;

  const chkObj = obj as {
    id?: unknown;
    subClauseId?: unknown;
    condition?: unknown;
    compoundExpression?: unknown;
  };

  // Check id is a non-blank string
  if (typeof chkObj.id !== "string" || chkObj.id === "") return false;

  // Check subClauseId is "" (empty string for non-referenced clauses)
  if (chkObj.subClauseId !== "") return false;

  // Must have a valid compoundExpression
  if (!isWhereClauseCompoundExpression(chkObj.compoundExpression)) return false;

  // Must not have condition property
  if (chkObj.condition !== undefined) return false;

  return true;
};
